import { RouteRecordRaw } from 'vue-router';
import { RecordViewPage, RECORD_VIEW_STAGE_CONFIG } from '@/pages/record-view';

export const routeName = 'DiretoriosVerRegistro';

export const route: RouteRecordRaw = {
  path: 'diretorios/ver-registro/:id',
  name: routeName,
  component: RecordViewPage,
  meta: {
    requiresAuth: true,
    breadcrumb: RECORD_VIEW_STAGE_CONFIG.directory.stageLabel,
    dynamicBreadcrumb: true,
    recordViewStage: 'directory',
    // The same right as the Diretórios screen: whoever lists a matrix in the add modal can read it.
    permissions: [{ action: 'read', subject: 'Directory' }],
  },
};
